
import { useEffect } from 'react';

import { useHybridApp } from './useHybridApp';

export const useHideSplashScreen = (routerReady: boolean) => {
  const { hybridApp } = useHybridApp();

  useEffect(() => {
    if (hybridApp && hybridApp.hideSplashScreen && routerReady) {
      hybridApp.hideSplashScreen();
    }
  }, [hybridApp, routerReady]);
};
